import { baseUrl } from "./requestsIndex";
import mainAxios from "./index";
import { auth, db, storage } from "./firebaseConfig";
import { addDoc, collection, doc, getDoc, getDocs, query, setDoc, updateDoc, where } from "firebase/firestore";
import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { updatePassword } from "firebase/auth";

// classroomId: 'e3bcd215df',
// let dataToUpdate = {
//   teacherId: "64ad3bc7cff30e2322349217",
//   classroomName: 'class D',
//   isActive: true
// }
// const classdocRef = doc(db, "classes", 'e3bcd215df');
// setDoc(classdocRef, dataToUpdate, { merge: true })
const userRef = collection(db, "users");


const userDebugg = async (dataToSend, userDetails) => {
  console.log("🚀 ~ userDebugg ~ userDetails:", userDetails)
  console.log("🚀 ~ userDebugg ~ dataToSend:", dataToSend)
  try {

    const errorRef = collection(db, "errors");
    let addingError = await addDoc(errorRef, { userDetails: userDetails.email, errorInfo: dataToSend });
    return addingError
  } catch (error) {
    console.log("🚀 ~ userDebugg ~ error:", error)

  }
}

//Add path routing
//Add authorization for each request


const updateUserDetails = async (userDetailsToUpdate, uid) => {
  try {

    const userDocRef = doc(db, 'users', uid);
    const userDocSnap = await getDoc(userDocRef);
    if (userDocSnap.exists()) {
      let user = userDocSnap.data();
      console.log("🚀 ~ updateUserDetails ~ user:", user)
      await setDoc(userDocRef, userDetailsToUpdate, { merge: true });
      if (userDetailsToUpdate.firstName) {
        await updateClassStudentRef("firstName", userDetailsToUpdate.firstName, { id: uid, ...user })
        await updateClassStudentRef("lastName", userDetailsToUpdate.lastName, { id: uid, ...user })
      }

    } else {
      throw { message: "missing details" }
    }
    let newUserDetails = (await getDoc(userDocRef)).data();
    return { ...newUserDetails, id: uid }
  } catch (error) {
    console.log("🚀 ~ file: userRequests.js:34 ~ updateUserDetails ~ error:", error)
    throw error
  }
};

const createNewUser = async (currentUser, formData) => {
  try {
    let user = await getUserDetailsByEmail(currentUser.email)
    if (user) {
      return user
    } else {
      let firstName;
      let lastName;
      if (currentUser.displayName) {

        const parts = currentUser.displayName.split(' ');
        firstName = parts.shift(); // Get the first word
        lastName = parts.join(' ');
      }
      // User doesn't exist, create a new record in the user collection
      const randomNumber = Math.floor(Math.random() * 10); // Generates a random integer between 0 (inclusive) and 11 (exclusive)

      const newUser = {
        permissions: 'viewer',
        lastName: currentUser.displayName ? lastName : formData?.lastName, // Use displayName from Google if available
        assessments: [],
        assessmentsSeen: [],
        assessmentsCurrIndex: randomNumber,
        email: currentUser.email,
        isActive: true,
        image: currentUser.photoURL ? currentUser.photoURL : '', // Use photoURL from Google if available
        TR: [],
        firstName: currentUser.displayName ? firstName : formData?.firstName, // Use displayName from Google if available
        TF: [],
        classId: null,
        calibration: '',
        password: '', // No need to store password when using Google auth
        level: null // Set the initial level here
      };
      let AddingUser = await addDoc(userRef, newUser)
      let fullUserDatails = await getUserDetailsByEmail(currentUser.email)
      console.log("🚀 ~ file: userRequests.js:60 ~ createNewUser ~ fullUserDatails:", fullUserDatails)
      return fullUserDatails;
    }
  } catch (error) {
    console.log("🚀 ~ file: userRequests.js:25 ~ createNewUser ~ error:", error)

  }
}




const changePass = async (currentUser, newPass) => {
  try {

    await updatePassword(currentUser, newPass)
    return { message: "The password has been successfully updated" }
  } catch (error) {
    throw error.message ? error : { message: "Something went wrong" }

  }


}
const updateUserAvatar = async (file, userDetails, oldImageName) => {
  return new Promise((resolve, reject) => {

    try {
      // Create the file metadata
      const metadata = {
        contentType: file.type,
      };
      // Generate a unique file name based on the current user's UID
      const fileName = `${userDetails.id}_${file.name}`;
      // Reference to the Firebase Storage location
      const storageRef = ref(storage, `images/${fileName}`);
      // Upload the file and metadata
      const uploadTask = uploadBytesResumable(storageRef, file, metadata);
      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on('state_changed',
        (snapshot) => {
          // Handle upload progress if needed
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log('Upload is ' + progress + '% done');
        },
        (error) => {
          // Handle errors
          throw { error }
        },
        () => {
          // Upload completed successfully, now get the download URL
          getDownloadURL(uploadTask.snapshot.ref).then(async (downloadURL) => {
            console.log('File available at', downloadURL);
            let updateUserData = await updateUserDetails({ image: downloadURL }, userDetails.id);
            let finalResponse = { ...userDetails, image: updateUserData.image }
            resolve(finalResponse);
            if (oldImageName) {
              console.log("🚀 ~ returnnewPromise ~ oldImageName:", oldImageName)

              const desertRef = ref(storage, `images/${oldImageName}`);

              // Delete the file
              deleteObject(desertRef).then(() => {
                console.log(`the old File ${oldImageName} deleted successfully`)
              }).catch((error) => {
                console.log("🚀 ~ deleteObject ~ error:", error)
                // Uh-oh, an error occurred!
              });
            }
            // You can now use downloadURL to display the image or store it in Firestore
          }).catch(error => reject(error));
        }
      );

    } catch (error) {
      console.error('Error uploading file:', error);
      reject(error)
    }
  })

};
const updateUserClassId = async (classDetails, uid) => {
  try {
    const classdocRef = doc(db, "classes", classDetails.classId);
    const classDocSnap = await getDoc(classdocRef);
    let classDatails
    if (classDocSnap.exists()) {
      classDatails = classDocSnap.data();
    } else {
      // docSnap.data() will be undefined in this case
      throw { message: "invalid class ID" }
    }
    const userDocRef = doc(db, 'users', uid);
    const userDocSnap = await getDoc(userDocRef);
    if (userDocSnap.exists()) {
      let user = userDocSnap.data();
      let basicUserDetails = { [uid]: { firstName: user.firstName, lastName: user.lastName, asses: 0, TR: 0, TF: 0 } }
      await setDoc(userDocRef, { classId: classDetails.classId, level: classDetails.level }, { merge: true });
      await setDoc(classdocRef, { students: { ...classDatails.students, ...basicUserDetails } }, { merge: true })
      let userUpdated = (await getDoc(userDocRef)).data()
      let res = { ...userUpdated, id: uid }
      console.log("🚀 ~ file: userRequests.js:106 ~ updateUserClassId ~ res:", res)
      return res
    } else {
      // docSnap.data() will be undefined in this case
      throw { message: "invalid user ID" }
    }

  } catch (error) {
    console.log("🚀 ~ file: userRequests.js:94 ~ updateUserClassId ~ error:", error)
    throw error

  }
};

const getUserDetailsByEmail = async (email) => {
  try {//TODO: adding rule to prevent data leak
    let q = query(userRef, where("email", "==", email));
    let userSnap = (await getDocs(q)).docs.map(doc => ({ ...doc.data(), id: doc.id }));
    let user = userSnap[0]
    if (user) {
      // await populateByField(user, "all")
      // let newUser = await updateUserDetails({ ...user, id: null }, user.id)
      console.log("🚀 ~ file: userRequests.js:137 ~ getUserDetailsByEmail ~ user:", user)
      // console.log("🚀 ~ file: userRequests.js:167 ~ getUserDetailsByEmail ~ newUser:", newUser)
      return user
    } else {
      return false
    }
  } catch (error) {
    console.log("🚀 ~ file: userRequests.js:58 ~ getUserDetails ~ error:", error)

  }

};



const addNewTf = async (tfValue, userDetails) => {
  let newData = { value: tfValue, date: new Date().toISOString() };
  let body = { TF: [...userDetails.TF, newData] };
  let updateDoc = await updateUserDetails(body, userDetails.id);
  let UserDetailsafterUpdate = { ...userDetails, TF: updateDoc.TF }
  await updateClassStudentRef("TF", tfValue, userDetails)
  return UserDetailsafterUpdate
};
const addNewTr = async (trValue, userDetails) => {
  let newData = { ...trValue, date: new Date().toISOString() };
  let body = { TR: [...userDetails.TR, newData] };
  let updateDoc = await updateUserDetails(body, userDetails.id);
  let UserDetailsafterUpdate = { ...userDetails, TR: updateDoc.TR }
  await updateClassStudentRef("TR", trValue.value, userDetails)
  return UserDetailsafterUpdate
};

const addAssesmentRes = async (body, userDetails) => {
  try {
    const userDocRef = doc(db, "users", userDetails.id);
    const userSnap = await getDoc(userDocRef)
    let userData
    if (userSnap.exists()) {
      userData = userSnap.data()
    } else {
      throw { message: "User Details are missing for some reason" }
    }
    const now = new Date().toISOString();
    let dataToSend = { ...body, date: now, isActive: true }
    // let userTestRef = collection(db, "usertests");
    // let newTest = await addDoc(userTestRef, dataToSend)
    let updateDoc = await updateUserDetails({ assessments: [...userData.assessments, dataToSend] }, userDetails.id);
    await updateClassStudentRef("asses", body.result.WPM, userDetails)
    // let userAfterUpdate = await populateByField(updateDoc, "assess")
    // return ({ ...userDetails, assessments: userAfterUpdate.assessments })
    return ({ ...updateDoc })
  } catch (error) {
    console.log("🚀 ~ file: userRequests.js:68 ~ addAssesmentRes ~ error:", error)
    throw error
  }
}

const updateClassStudentRef = async (type, newValue, userDetails) => {
  try {

    const classdocRef = doc(db, "classes", userDetails.classId);
    let dotNotation = `students.${userDetails.id}.${type}`
    await updateDoc(classdocRef, { [dotNotation]: newValue })

  } catch (error) {
    console.log("🚀 ~ updateClassStudentRef ~ error:", error)
    throw error
  }
}
// const checkForNewAssessment = async (userDetails) => {
//   try {
//     let newAssess
//     const tastsdocRef = doc(db, "tests", "10-1-Amundsen");
//     const tastsDocSnap = await getDoc(tastsdocRef);
//     if (tastsDocSnap.exists()) {
//       let testData = tastsDocSnap.data();
//       newAssess = { ...testData, id: "10-1-Amundsen" }//TODO: replase it with real id
//       console.log("🚀 ~ file: userRequests.js:164 ~ checkForNewAssessment ~ newAssess:", newAssess)
//     } else {
//       throw { message: "Invalid Test ID" }
//     }
//     return newAssess
//   } catch (error) {
//     console.log("🚀 checkForNewAssessment ~ error:", error)
//     throw error
//   }
// }

const getAssessNSum = async (userDetails) => {
  console.log("🚀 ~ file: userRequests.js:256 ~ getAssessNSum ~ userDetails:", userDetails)
  try {
    const testRef = collection(db, "tests");
    const allTest = (await getDocs(testRef)).docs.map(doc => ({ ...doc.data(), id: doc.id }));
    const allTestByLevel = allTest.filter(test => test.level == userDetails.level)
    if (userDetails.assessmentsCurrIndex == undefined || userDetails.assessmentsCurrIndex == null) {//handle when user exist but havnt sign in yet
      const randomNumber = Math.floor(Math.random() * 10); // Generates a random integer between 0 (inclusive) and 11 (exclusive)
      userDetails = await updateUserDetails({ assessmentsCurrIndex: randomNumber }, userDetails.id);
    }
    if (userDetails.assessments.length == 0) {
      return { sum: allTestByLevel.length, assess: allTestByLevel[userDetails.assessmentsCurrIndex] }
    } else {
      let weekIsPassed = hasWeekPassed(userDetails.assessments[userDetails.assessments.length - 1].date);
      return { sum: allTestByLevel.length, assess: weekIsPassed ? allTestByLevel[userDetails.assessmentsCurrIndex] : null }
    }
  } catch (error) {
    console.log("🚀 ~ file: userRequests.js:206 ~ getAssessSum ~ error:", error)

  }
}


const populateByField = async (user, field) => {
  let { assessments, TF, TR } = user;
  let PopAssess = [], PopTF = [], PopTR = [];
  if (assessments.length && (field == "assess" || field == "all")) {
    for (const assessID of assessments) {
      const assessdocRef = doc(db, "usertests", assessID);
      const assessDocSnap = await getDoc(assessdocRef);
      if (assessDocSnap.exists()) {
        let docData = { ...assessDocSnap.data(), id: assessDocSnap.id }
        PopAssess.push(docData)
      }
    }
    user.assessments = [...PopAssess]
  }
  if (TR.length && (field == "TR" || field == "all")) {//TODO: handle with add new TR
    for (const TRID of TR) {
      const TRdocRef = doc(db, "usertrainreadings", TRID);
      const TRDocSnap = await getDoc(TRdocRef);
      if (TRDocSnap.exists()) {
        let docData = { ...TRDocSnap.data(), id: TRDocSnap.id }
        PopTR.push(docData)
      }
    }
    user.TR = [...PopTR]
  }
  return user
}


function hasWeekPassed(timestamp) {
  const now = new Date();
  const oneWeekAgo = new Date(now.getTime() - 6.5 * 24 * 60 * 60 * 1000); // Subtract 7 days in milliseconds
  // const oneWeekAgo = new Date(now.getTime() - 5 * 60 * 1000); // Subtract 5 minutes in milliseconds

  const timestampDate = new Date(timestamp);
  // return true
  return timestampDate <= oneWeekAgo;
}

const userRequests = {
  createNewUser,
  updateUserDetails,
  getUserDetails: getUserDetailsByEmail,
  updateUserAvatar,
  updateUserClassId,
  addNewTf,
  addAssesmentRes,
  // checkForNewAssessment,
  getAssessNSum,
  addNewTr,
  changePass,
  userDebugg
};
export default userRequests;
